import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBook, FaCog, FaHome, FaTrophy, FaBell, FaUserCircle, FaEnvelope, FaPencilAlt, FaPlusCircle, FaSignOutAlt, FaMicrochip } from 'react-icons/fa';

import { RiLogoutCircleRFill } from "react-icons/ri";
import { GlobalContext } from '../../context/provider';
import useAuth from '../../hooks/useAuth';


import './sharedHeader.css';

const SharedHeader = ({ notificationCount, courseId, domainId, icons = [] }) => {
  const navigate = useNavigate();

  const { 
    authState: { authData, isLoggedIn }, 
    authDispatch,
  } = useContext(GlobalContext);

  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };
  
  const handleAddCircuit = (courseId) => {
      try {
          // ✅ Validate authData first
          if (!authData || !authData.id) {
          alert('⚠️ Please wait, loading user data...');
          console.error('❌ authData not available');
          return;
          }

          if (!courseId) {
          alert('⚠️ Course ID not available');
          console.error('❌ courseId not available');
          return;
          }

          // ✅ PATH 2: Just navigate to empty builder (NO circuit creation)
          const url = `/iot/course/${courseId}/circuit/build`;
          // console.log('🚀 PATH 2: Opening empty circuit builder');
          // console.log('🚀 URL:', url);
          
          window.open(url, '_blank', 'noopener,noreferrer');
          
      } catch (err) {
          console.error('❌ Error opening circuit builder:', err);
          alert('❌ Failed to open circuit builder');
      }
  };

  const handleAddCanvas = () => {
    try {
        // ✅ Validate authData first
        if (!authData || !authData.id) {
        alert('⚠️ Please wait, loading user data...');
        console.error('❌ authData not available');
        return;
        }

        if (!courseId) {
        alert('⚠️ Course ID not available');
        console.error('❌ courseId not available');
        return;
        }

        // ✅ PATH 2: Just navigate to empty builder (NO circuit creation)
        const url = `/labengine/course/${courseId}/domain/${domainId}/buildcanvas`;
        // console.log('🚀 PATH 2: Opening empty circuit builder');
        // console.log('🚀 URL:', url);
        
        window.open(url, '_blank', 'noopener,noreferrer');
        
    } catch (err) {
        console.error('❌ Error opening circuit builder:', err);
        alert('❌ Failed to open circuit builder');
    }
  };

  return (
    <div className="header-container">
    
      {/* Home Icon */}
      {/* {icons.includes('home') && (
        <button className="icon-button" onClick={() => navigate('/home')}>
          <FaHome size={22} color="#fff" />
        </button>
      )} */}

      {/* Courses/Modules Icon */}
      {icons.includes('envelope') && (
        <div className="icon-wrapper">
          <button className="icon-button" onClick={() => navigate('/contactAdmin')}>
            <FaEnvelope size={22} color="#fff" />
          </button>
          {notificationCount>0 && <span className="sharedHeader-badge">{notificationCount}</span>}
        </div>
      )}

      {/* Write Note Icon */}
      {icons.includes('writenote') && (
        <button className="icon-button" onClick={() => navigate('/admin/writenote')}>
          <FaPencilAlt size={22} color="#fff" />
        </button>
      )}

      {/* Progress/Achievements Icon */}
      {icons.includes('addDevice') && (
        <button className="icon-button" onClick={() => handleAddCircuit(courseId)}>
          <FaPlusCircle size={22} color="#fff" />
        </button>
      )}

      {/* Progress/Achievements Icon */}
      {icons.includes('addCanvas') && (
        <button className="icon-button" onClick={handleAddCanvas}>
          <FaPlusCircle size={22} color="#fff" />
        </button>
      )}

      {/* Settings Icon */}
      {icons.includes('settings') && (
        <button className="icon-button" onClick={() => navigate('/settings')}>
          <FaCog size={22} color="#fff" />
        </button>
      )}

      {/* Notification Icon with Badge */}
      {icons.includes('notifications') && (
        <div className="icon-wrapper">
          <button className="icon-button" onClick={() => navigate('/notifications')}>
            <FaBell size={22} color="#fff" />
          </button>
          {notificationCount > 0 && (
            <span className="sharedHeader-badge">{notificationCount}</span>
          )}
        </div>
      )}

      {/* Profile Icon */}
      {icons.includes('profile') && (
        <button className="icon-button" onClick={() => navigate('/profile')}>
          <FaUserCircle size={22} color="#fff" />
        </button>
      )}

      {/* Logout Icon */}
      <button className="icon-button" onClick={handleLogout}>
        <FaSignOutAlt size={22} color="#FF9800" />
        {/* <RiLogoutCircleRFill size={22} color="#FF9800" /> */}
      </button>

    </div>
  );
};

export default SharedHeader;